import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';

@Pipe({ name: 'formatCurrency', pure: false })
export class FormatCurrencyPipe implements PipeTransform {
  constructor(private currency: CurrencyService) {}

  transform(value: number | string): string {
    if (value === null || value === undefined) return '';

    const num    = typeof value === 'string' ? +value : value;
    const locale = this.currency.locale;         
    const code   = this.currency.code;           

    const parts = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
    }).formatToParts(num);

    return parts
      .map(p => p.type === 'currency' ? `${p.value} ` : p.value)
      .join('');
  }
}
